import React from 'react';
import styled from 'styled-components';

const FooterWrapper = styled.div`
  box-sizing: border-box;
  padding: 3.75rem 22.5rem;
  background: #f3f4f5;
  font-size: 0.75rem;
  color: #767676;

  p {
    padding-top: 0.5rem;
  }

  h6 {
    padding-top: 1rem;
    font-weight: 500;
  }

  @media screen and (max-width: 1199px) {
    padding: 2.5rem 3.125rem;
    text-align: center;

    p {
      line-height: 1rem;
    }
  }
`;

const Footer = () => {
  return (
    <FooterWrapper>
      <p>상호명: 어시장 쇼핑몰 주소: 인천 중구 연안부두로 3</p>
      <p>
        대표: 홍길동 사업자 등록번호: 123-12-123 통신판매업신고번호:
        2020-인천연안-1234호 메일: webmaster@yeonan.co.kr
      </p>
      <p>
        전화번호: 032-1234-1234 팩스번호: 032-123-4123 메일:
        webmaster@yeonan.co.kr
      </p>
      <h6>copyright⒞ 연안부두어시장 all rights reserved.</h6>
    </FooterWrapper>
  );
};

export default Footer;
